export const FACILITY_FRAME_ID = 'facility-frame';
export const APP_CONTAINER_ID = 'app-container';
export const SCROLL_CONTAINER_ID = 'scroll-container';
export const PAGE_CONTENT_CONTAINER_ID = 'page-content-container';
export const TOP_NAVIGATION_CONTAINER_ID = 'top-navigation-container';
export const BOTTOM_STICKY_PORTAL_ID = 'bottom-sticky-portal';
